import { Link } from "react-router-dom";
import { Linkedin, GraduationCap, Briefcase, Award, ArrowRight, Quote } from "lucide-react";
import { TEAM } from "../mock";

export default function Team() {
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0a2540] to-[#1e40af] text-white py-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{backgroundImage: "radial-gradient(circle at 20% 30%, rgba(244,181,45,0.35), transparent 40%), radial-gradient(circle at 80% 70%, rgba(47,107,216,0.4), transparent 40%)"}} />
        <div className="container-x relative z-10">
          <div className="text-xs uppercase tracking-[3px] opacity-80">Our People</div>
          <h1 className="brand-serif text-4xl md:text-5xl font-extrabold mt-2">Meet the Team</h1>
          <p className="max-w-2xl mt-4 text-slate-200 leading-relaxed">
            A leadership team combining global banking pedigree, cross-border commercial experience and world-class academic credentials.
          </p>
          <div className="text-sm mt-4 opacity-80">
            <Link to="/" className="hover:text-amber-300">Home</Link> / Team
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x space-y-14">
          {TEAM.map((m, i) => (
            <div key={m.name} className={`grid md:grid-cols-5 gap-10 items-center ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}>
              <div className="md:col-span-2 relative">
                <div className="rounded-3xl overflow-hidden shadow-2xl border-8 border-white">
                  <img src={m.image} alt={m.name} className="w-full h-[500px] object-cover" />
                </div>
                <div className="dot-grid absolute -bottom-6 -right-6" />
                <div className="stat-glass absolute -bottom-6 left-6 flex items-center gap-3 max-w-[260px]">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#1e40af] to-[#0a2540] text-white flex items-center justify-center">
                    <Briefcase size={18} />
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-widest text-slate-500">Previously</div>
                    <div className="text-[#0a2540] font-bold text-sm leading-tight mt-0.5">{m.prev}</div>
                  </div>
                </div>
              </div>

              <div className="md:col-span-3">
                <div className="section-eyebrow">{m.role}</div>
                <h2 className="section-title mt-2">{m.name}</h2>
                <p className="text-slate-600 mt-4 leading-relaxed text-lg">{m.bio}</p>

                <div className="mt-8 grid sm:grid-cols-2 gap-4">
                  <div className="p-5 rounded-2xl bg-[#eff6ff] border border-slate-100">
                    <div className="flex items-center gap-2 text-[#1e40af] font-bold">
                      <GraduationCap size={18} /> Education
                    </div>
                    <ul className="mt-3 space-y-2 text-sm text-slate-700">
                      {m.education.map((e) => (
                        <li key={e} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#1e40af] mt-1.5 shrink-0" /> {e}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="p-5 rounded-2xl bg-gradient-to-br from-[#fff8ea] to-[#fef3c7] border border-amber-100">
                    <div className="flex items-center gap-2 text-[#92400e] font-bold">
                      <Award size={18} /> Areas of Expertise
                    </div>
                    <div className="flex flex-wrap gap-2 mt-3">
                      {m.expertise.map((x) => (
                        <span key={x} className="px-3 py-1 rounded-full bg-white text-[#0a2540] text-xs font-semibold border border-amber-200">{x}</span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex items-center gap-3">
                  <a href={m.linkedin} className="w-10 h-10 rounded-full bg-[#0a66c2] text-white flex items-center justify-center hover:scale-110 transition-transform" aria-label={`${m.name} LinkedIn`}>
                    <Linkedin size={18} />
                  </a>
                  <Link to="/contact" className="btn-outline">Work with {m.name.split(" ")[0]} <ArrowRight size={16} /></Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-[#eff6ff]">
        <div className="container-x">
          <div className="max-w-3xl mx-auto text-center">
            <Quote size={40} className="text-[#1e40af] mx-auto" />
            <p className="text-2xl text-[#0a2540] font-semibold mt-4 leading-snug">
              &ldquo;Our people are the reason clients keep coming back &mdash; a blend of world-class banking pedigree and a genuinely human approach to finance.&rdquo;
            </p>
            <div className="mt-4 text-sm text-slate-500">&mdash; Leadership, Fortunexis LLC</div>
          </div>
        </div>
      </section>
    </div>
  );
}
